import ReactPixel from 'react-facebook-pixel';

const options = {
  autoConfig: true,
  debug: false,
};

const pushToDataLayer = (payload) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

const initFacebookPixel = () => {
  ReactPixel.init('25302818349322210', {}, options);
  const path = window.location.pathname;
  ReactPixel.pageView(path);
  pushToDataLayer({ event: 'pageView', page_path: path });
};

const trackEvent = (event, data = {}) => {
  ReactPixel.track(event, data);
  pushToDataLayer({ event, ...data });
};

const trackPageView = (pathname) => {
  const pagePath = pathname || window.location.pathname;
  ReactPixel.pageView(pagePath);
  pushToDataLayer({ event: 'pageView', page_path: pagePath });
};

export { initFacebookPixel, trackEvent, trackPageView };
